import { useSuspenseQuery } from '@tanstack/react-query';
import { GatheringSpotType } from '@outdoria/types';
import { fetcher } from '../utils';
import { GATHERING_SPOT_TYPE } from '../queryKeys';

export const useGetGatheringSpotTypeById = (
  gathering_spot_type_id?: string,
) => {
  const queryFn = async (): Promise<GatheringSpotType> => {
    const res = await fetcher(
      `/v2/gathering_spot_types/${gathering_spot_type_id}`,
    );
    return res.json();
  };

  const { data, isLoading, isFetched, isError } = useSuspenseQuery<
    GatheringSpotType,
    unknown,
    GatheringSpotType,
    string[]
  >({
    queryKey: [...GATHERING_SPOT_TYPE, gathering_spot_type_id!],
    queryFn,
  });

  return { data, isLoading, isFetched, isError };
};
